import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const ContentContainer = ({ className, as: Component, ...props }) => (
  <Component
    className={clsx('max-w-[1440px] mx-auto px-6 lg:px-12', className)}
    {...props}
  />
)

export default ContentContainer

ContentContainer.propTypes = {
  className: PropTypes.string,
  as: PropTypes.node
}

ContentContainer.defaultProps = {
  className: '',
  as: 'div'
}
